import { MiddlewareAPI, Action } from 'redux'
import { Observable } from 'rxjs/Observable'
import { Epic } from 'redux-observable'
import { MT4Connector } from '@bdswiss/mt4-connector'

import { RootState } from '../types'
import { TOGGLE_ASSETS, SET_ASSETS_GROUP, SET_APP_MODE } from '../constants'
import { SetAssetsGroup } from '../actions'
import { SetAppMode } from '../actions/commonActions'

const mt4: MT4Connector = MT4Connector.Instance

export const handleAllSubscriptionEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(TOGGLE_ASSETS).mergeMap(action => {
    if (state.getState().appState.assetsOpened) {
      mt4.subscribeToSymbol('@ALL')
    } else {
      mt4.unsubscribeFromSymbol('@ALL')
    }
    return Observable.empty()
  })

export const handleSetAssetsGroupEpic: Epic<SetAssetsGroup, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(SET_ASSETS_GROUP).mergeMap(action => {
    if (action.group === 'signals') {
      mt4.unsubscribeFromSymbol('@ALL')
    } else {
      mt4.subscribeToSymbol('@ALL')
    }
    return Observable.empty()
  })

export const handleSetAppModeEpic: Epic<SetAppMode, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(SET_APP_MODE).mergeMap(action => {
    if (action.mode === 'trade') {
      if (state.getState().appState.assetsOpened) {
        mt4.subscribeToSymbol('@ALL')
      } else {
        mt4.unsubscribeFromSymbol('@ALL')
      }
    }
    return Observable.empty()
  })
